import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { loginWithPopup } from '../../services/msalService';
import Error from '../../components/Error';
import Delivery from '../../assets/images/contract.jpeg'
import FoodConceptLogo from '../../assets/images/FoodConcepts_Logo-1 1.png'

const SignIn = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async () => {
        // Prevent multiple login attempts
        if (error || isLoading) return;

        setIsLoading(true);
        setError(false);
        setErrorMessage(null);

        try {
            // Use centralized MSAL service for login
            const result = await loginWithPopup();

            if (result.success) {
                // Login successful
                toast.success('Login successful');
                navigate('/approval/home');
            } else {
                // Login failed - show error
                setError(true);
                setShowModal(true);
                setErrorMessage(result.error);
            }

        } catch (error) {
            console.error("Login Error:", error);
            setError(true);
            setShowModal(true);
            setErrorMessage('An unexpected error occurred. Please try again.');
        } finally {
            setIsLoading(false);
        }
    }

    return (
       <div className='h-screen'>
        <div className='bg-white h-16 flex items-center w-full'>
            <div className='flex items-center py-4 px-8'>
           <img src={FoodConceptLogo}  alt="" className='h-16 pr-2' />
            <h1 className="text-lg text-center pl-2 border-l border-gray-400 font-medium text-blue-900 hidden md:flex">
     Invoice Management Portal
            </h1> 
            </div>
        </div>
         <div className="relative h-full bg-cover bg-center" style={{ backgroundImage: `url(${Delivery})` }}>
        {/* <div className="relative h-screen bg-contain bg-no-repeat bg-center" style={{ backgroundImage: `url(${Delivery})` }}> */}
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
           
            <div className="flex flex-col w-[80%] md:w-[40%] text-center justify-center items-center">
           
            <p className="text-4xl font-bold text-white mb-3">Invoice Approval Portal</p>
            <p className="text-sm font-normal text-white mb-3">Enhancing efficiency and transparency in managing invoice approvals </p>
       
            <button
              className="bg-blue-700 hover:bg-blue-800 text-white font-semibold mt-8 py-3 px-6 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
              type="button"
              disabled={isLoading}
              onClick={handleLogin}
            >
              {isLoading ? 'Signing in...' : 'Get Started'}
            </button>
            </div>
           
           
          
            </div>
            {error && <Error message={errorMessage} show={showModal} handleShow={() => setShowModal(false)} />}
        </div>
       </div>
    );
};

export default SignIn;